import { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { removeNoteAction as removeNote } from '../../../../../../services/RefundService/slice';
import { NoteView } from '../../../../../../services/RefundService/types/refundTypes';
import { useGetMyProfileQuery } from '../../../../../../services/ProfileService';

export interface UseViewNoteReturn {
  canDelete: boolean;
  handleDelete: () => void;
}

export interface UseViewNoteOptions {
  note: NoteView | null;
  onClose: () => void;
}

export function useViewNote({ note, onClose }: UseViewNoteOptions): UseViewNoteReturn {
  const dispatch = useAppDispatch();
  const { data: userProfile } = useGetMyProfileQuery();

  const canDelete = (() => {
    if (!note || !userProfile) return false;
    const currentUserIdentity = userProfile.identity || userProfile.name;
    return note.addedBy === currentUserIdentity;
  })();

  const handleDelete = useCallback(() => {
    if (note?.id) {
      const confirmed = window.confirm(
        'Are you sure you want to delete this note? This action cannot be undone.'
      );
      if (confirmed) {
        dispatch(removeNote(note.id));
        onClose();
      }
    }
  }, [note, dispatch, onClose]);

  return {
    canDelete,
    handleDelete,
  };
}
